import React, { forwardRef, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import { useForm } from "react-hook-form";

import { DataTable, ProjectCard, PDFViewCard } from '../../Components';
import { IdentifyTypeName } from '../../Utils/Prefix';
import { DateThaiFormat, GradeLevelName } from '../../Utils/Function';
import Swal from 'sweetalert2';
import API from '../../API';
import '../../App.css';

const SchoolView = forwardRef((props, ref) => {
    const { register, getValues, setValue } = useForm();
    const RedirectTo = useNavigate()
    const _PDFViewCard = useRef();
    const _ProjectView = useRef();

    useEffect(() => {
        (async () => {
        })();

        return () => { }
    }, []);


    const _configs = {
        "order": [[0, "asc"]],
        pageLength: 25,
        orderMulti: true
    }
    const _ajax = {
        'url': '/Staff/School/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {}
    };

    const _Buttons = (d, r) => (
        <div className='btn-group btn-group-sm'>
            <button type='button' title='รายละเอียด' className='btn btn-info text-white' onClick={() => { }}>Info</button>
        </div>
    )
    const _column = [
        { data: "SchoolName", name: "SchoolName", autoWidth: true },
        { data: "FullName", name: "FullName", autoWidth: true },
        { data: "CityName", name: "CityID", autoWidth: true },
        { data: "ProvinceName", name: "ProvinceID", autoWidth: true },
        {
            data: "SchoolID", name: "SchoolID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData, rowData) => createRoot(td).render(_Buttons(cellData, rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    const _Update = async () => {
        _ProjectView.current?.load()

    }
    const _ADD = async () => {

    }
    return (
        <>
            <React.Fragment>
                <div className='row'>
                    <div className='col-lg-12 mt-2'>
                        <div className='row mb-4'>
                            <div className='col-12'>
                                <div className='card'>
                                    <div className='card-header'>
                                        <div className='card-title fs-5 fw-semibold'>
                                            <div className='row'>
                                                <div className='col-lg-8'><h4 className='text-start mt-2'>รายชื่อข้อมูลโรงเรียน</h4></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='card-body'>
                                        <div className='row mt-2 mb-2 justify-content-end'>
                                            <div className='col-lg-1 text-end'>
                                                <div className='btn-group'>
                                                    <button type='button' className='btn btn-info text-white' onClick={() => { _Update(); }}>ค้นหา</button>
                                                    <button type='button' className='btn btn-success text-white' onClick={() => { _ADD(); }}>เพิ่ม</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-2 mb-2'>
                                            <div className='col-12 table-responseive'>
                                                <div className='table-response'>
                                                    <table className='table' id="ProjectView">
                                                        <thead>
                                                            <tr>
                                                                <th className='text-center textleft'>ชื่อโรงเรียน</th>
                                                                <th className='text-center textleft '>ชื่อเต็ม</th>
                                                                <th className='text-center textcenter'>อำเภอ</th>
                                                                <th className='text-center textcenter no-sort'>จังหวัด</th>
                                                                <th className='text-center textcenter no-sort'>#</th>
                                                            </tr>
                                                        </thead>
                                                        <DataTable TableID={"ProjectView"} Column={_column} Configs={_configs} ref={_ProjectView} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </React.Fragment>
            <PDFViewCard ref={_PDFViewCard} />
        </>
    )
});
export default React.memo(SchoolView)